<script lang="ts">
  import { Col, Container, Row } from "sveltestrap";
  import BookmarkFontawesome from "./BookmarkFontawesome.svelte";
  import Card from "../../Core/Card.svelte";
  import Currencyicons from "./Currencyicons.svelte";
  import Webappicons from "./Webappicons.svelte";
  import Spinnericon from "./Spinnericon.svelte";
  import Formcontrolicon from "./Formcontrolicon.svelte";
  import Texteditoricon from "./Texteditoricon.svelte";
  import Directional from "./Directional.svelte";
  import Videoplayericon from "./Videoplayericon.svelte";
  import Brandplayericon from "./Brandplayericon.svelte";
  import Medicalplayericon from "./Medicalplayericon.svelte";
  import FontawsomeData from '../../../Data/IconsData/FontawesomeIcons.json';
  import {Icons } from "../../../utils/Constant/Constant";
  import {iTag,icons,iconClick} from "../../../store"
  import IconBottom from "../IconBottom.svelte";
    function getItag(tag:any) {
        iTag.update(value => value = `<i class="fa fa-${tag}"></i>`);
        icons.update(value=> value = `fa fa-${tag} fa-2x`) ;
        iconClick.update(value => value = true);
    }
</script>
<BookmarkFontawesome />
<Container fluid>
    <Row>
      <Col sm="12">
        <Card cardHeaderprops="pb-0">
            <div slot="customheader">
                <h5 class="m-b-0">
                    <span class="digits">20</span> {Icons}
                </h5>
            </div>
          <div slot="contentbody">
            <Row class="icon-lists">
              {#each FontawsomeData[0].icons20 as icon}
                <Col sm="6" md="4" xl="3">
                  <!-- svelte-ignore a11y-click-events-have-key-events -->
                  <div class="media" on:click={() => getItag(icon)}>
                    <i class={`fa fa-${icon}`} />
                    {'fa fa-'}{icon}
                  </div>
                </Col>
              {/each}
            </Row>
          </div>
        </Card>
      </Col>
      <Currencyicons />
      <Webappicons />
      <Spinnericon />
      <Formcontrolicon />
      <Texteditoricon />
      <Directional />
      <Videoplayericon />
      <Brandplayericon />
      <Medicalplayericon />
    </Row>
</Container>
<IconBottom />